import { render, staticRenderFns } from "./VCardComponent.vue?vue&type=template&id=69a5ee04"
import script from "./VCardComponent.vue?vue&type=script&lang=js"
export * from "./VCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports